// Components
import { concatStyleSets, Facepile as FabricFacepile } from "@fluentui/react";
import { UserContainer } from "../user/UserContainer";
// Styles
import { customFacepileStyles } from "./Facepile.styles";
// Utilities
import * as React from "react";
/**
 * Facepile control that customizes the fabric control to our own purposes
 */ export function Facepile(props) {
    const propsWithUserContainer = {
        ...props,
        styles: concatStyleSets(customFacepileStyles, props.customStyles),
        getPersonaProps: (persona)=>({
                onRenderCoin: (coinProps, defaultCoinContainer)=>{
                    const childElement = defaultCoinContainer(coinProps);
                    if (persona?.data?.user != null) {
                        const user = persona.data.user;
                        const userContainerProps = {
                            user: user,
                            onLoad: props.onRenderUserPersona,
                            containerId: `userContainer-facepile-${user.id}`
                        };
                        return /*#__PURE__*/ React.createElement(UserContainer, userContainerProps, childElement);
                    } else {
                        return childElement;
                    }
                }
            })
    };
    return /*#__PURE__*/ React.createElement(FabricFacepile, propsWithUserContainer);
}
